import * as React from "react";
import { useNavigation } from "@react-navigation/native";

import * as routes from "~/constants/routes";
import { ButtonTypes } from "~/components/button/types";
import { Button } from "~/components/button";

import { Container, Title, Disclaimer } from "./styles";
import { messages } from "./intl";

export const KidminButtons = () => {
  const navigation = useNavigation();

  const navigateToSignUp = React.useCallback(
    () => navigation.navigate(routes.signUp),
    [navigation]
  );

  return (
    <Container>
      <Title>{messages.buttonsTitle}</Title>
      <Button
        text={messages.buttonsCreate}
        onPress={navigateToSignUp}
        type={ButtonTypes.Secondary}
        isUppercase
      />
      <Disclaimer>{messages.buttonsDescription}</Disclaimer>
    </Container>
  );
};
